import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectAccount } from './account.selector.ts';

export const selectUserAuthStatus = createMemoizedSelector(selectAccount, (currentAccount): boolean =>
  Boolean(currentAccount?.userId)
);
